import { render } from "./RecruitmentNewCompanyEditor.vue?vue&type=template&id=4fca2544&scoped=true"
import script from "./RecruitmentNewCompanyEditor.vue?vue&type=script&lang=js"
export * from "./RecruitmentNewCompanyEditor.vue?vue&type=script&lang=js"

import "./RecruitmentNewCompanyEditor.vue?vue&type=style&index=0&id=4fca2544&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fca2544"]])

export default __exports__